import { useTranslation } from 'react-i18next';
import CustomSelectField from 'components/forms/customSelectField/CustomSelectField';
import TooltipContentWithLearnMore from 'pages/property/common/tooltip/TooltipContentWithLearnMore';
import { getAirbnbCancellationPolicyDescription } from 'utils/airbnb/cancellationPolicyUtils';

interface Props {
  name: string;
  label: React.ReactNode;
  options: { value: string; label: string }[];
  colSmInput?: number;
  colSmLabel?: number;
  labelOnTop?: boolean;
  required?: boolean;
  isSearchable?: boolean;
  isClearable?: boolean;
  showTooltip?: boolean;
  containerClassName?: string;
  dataTestId?: string;
}

const AirbnbCancellationPolicyField = ({
  name,
  label,
  options,
  colSmInput = 7,
  colSmLabel = 5,
  labelOnTop = false,
  required = false,
  isSearchable = true,
  isClearable = false,
  showTooltip = true,
  containerClassName,
  dataTestId,
}: Props) => {
  const { t } = useTranslation();

  const optionRenderer = ({
    children,
    data: { value },
  }: {
    children: React.ReactNode;
    data: { value: string };
  }) => {
    const description = getAirbnbCancellationPolicyDescription(value, t);

    return (
      <div data-testid={`cancellationPolicyOption-${value}`}>
        <div data-testid="label">
          <b>{children}</b>
        </div>
        {description && <div data-testid="description">{description}</div>}
      </div>
    );
  };

  return (
    <CustomSelectField
      label={label}
      name={name}
      options={options}
      optionRenderer={optionRenderer}
      colSmInput={colSmInput}
      colSmLabel={colSmLabel}
      labelOnTop={labelOnTop}
      required={required}
      isSearchable={isSearchable}
      isClearable={isClearable}
      containerClassName={containerClassName}
      rightTooltip={
        showTooltip ? (
          <TooltipContentWithLearnMore
            labelTooltipText={t(
              'pageProperty.mainSettings.airbnbSettings.cancellationPolicyTooltip',
            )}
            learnMoreUrl="https://help.hostfully.com/en/articles/1598674-activate-airbnb-channel#h_e72e9e0c72"
          />
        ) : undefined
      }
      data-testid={dataTestId}
    />
  );
};

export default AirbnbCancellationPolicyField;
